<template>
  <article
    class="page page-orders my-orders"
    :class="!(orders && orders.length > 0) ? 'flex items-center justify-center' : ''"
  >
    <section>
      <AppSpinner
        v-if="loading"
        class="page-spinner"
      />

      <template v-else>
        <template v-if="orders && orders.length > 0">
          <h1>My Orders</h1>

          <!-- Orders -->
          <ul class="orders">
            <template
              v-for="order in orders"
              :key="order.id"
            >
              <OrderItem :order="order" />
            </template>
          </ul>

          <!-- Pagination -->
          <AppPagination
            target-id="topOfPage"
            :items-per-page="paginationData?.itemsPerPage"
            :current-page="paginationData?.page"
            :total-items="paginationData?.total"
            class="mt-3"
            @change="handlePageChange"
          />
        </template>

        <template v-else>
          <EmptyViewPlaceholder message="You currently have no order history" />
        </template>
      </template>
    </section>
  </article>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { onMounted, onUnmounted, ref } from 'vue';

import { AppPagination, AppSpinner } from '@/components/app';
import { OrderItem } from '@/components/orders';
import { EmptyViewPlaceholder } from '@/components/placeholders';

import { useHttp } from '@/composables';

const searchParams = {
  page: 1,
  itemsPerPage: 10,
};

const orders = ref({});
const loading = ref(false);
const paginationData = ref(null);
const isSmallViewport = ref(window.innerWidth < 768);

onMounted(() => {
  window.addEventListener('resize', checkViewportSize);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkViewportSize);
});

const handlePageChange = page => {
  searchParams.page = page;

  loadOrders();
};

const loadOrders = async () => {
  loading.value = true;

  const response = await useHttp().get('/orders', searchParams);

  if (response.statusCode === HttpStatusCode.Ok) {
    orders.value = response.data.items;
    paginationData.value = response.data.pagination;
  }

  loading.value = false;
};

const checkViewportSize = () => {
  isSmallViewport.value = window.innerWidth < 768;
};

loadOrders();

</script>
